// Redsys redirect connection (ADR-0069): the browser posts the form the API
// signed. Only the three signed fields go to Redsys.
const FIELDS = ['Ds_SignatureVersion', 'Ds_MerchantParameters', 'Ds_Signature']

export const submitPaymentForm = (form, doc = document) => {
  const element = doc.createElement('form')
  element.method = 'POST'
  element.action = form.url
  element.style.display = 'none'
  for (const name of FIELDS) {
    const input = doc.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = form[name]
    element.appendChild(input)
  }
  doc.body.appendChild(element)
  element.submit()
}
